import { render, staticRenderFns } from "./commListJccg.vue?vue&type=template&id=45717cb6&scoped=true"
import script from "./commListJccg.vue?vue&type=script&lang=js"
export * from "./commListJccg.vue?vue&type=script&lang=js"
import style0 from "./commListJccg.vue?vue&type=style&index=0&id=45717cb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45717cb6",
  null
  
)

export default component.exports